// PIP-3358: hash deep-link pre-selection publishes PRODUCT_COLOR_SELECTED so
// image/price consumers still react, but it is not a user click — analytics
// listeners must skip it. Centralized so the guard is unit-testable without
// importing the full product-details module graph.
const shouldTrackColorClick = payload => payload?.userInitiated !== false;

export default shouldTrackColorClick;
